import { Campaign, MenuItemNavigation, Ranking, UserInDetails, defaultImage } from '@hub/shared'
import { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Link, useNavigate } from 'react-router-dom'
import './engage-header.component.scoped.scss'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  userInCampaign: UserInDetails
  path: string
  userRanking: Ranking
  userRankingLast: Ranking
  prizesCount?: number
  campaign: Campaign
}

export default ({ userInCampaign, path, userRanking, userRankingLast, prizesCount = 0, campaign }: Props) => {
  const [t, i18n] = useTranslation('engage')
  const navigate = useNavigate()
  const [menu, setMenu] = useState<Array<MenuItemNavigation>>([
    {
      label: t('header.menu.rules'),
      path: `${path}/rules`,
    },
    {
      label: t('header.menu.pointing'),
      path: `${path}/pointing`,
    },
  ])

  useEffect(() => {
    const toConcat = []
    if (!campaign?.activation?.disableRankingVisualization) {
      toConcat.push({
        label: t('header.menu.ranking'),
        path: `${path}/ranking`,
      })
    }
    if (prizesCount > 0) {
      toConcat.push(
        {
          label: t('header.menu.prizes'),
          path: `${path}/prizes`,
        },
        {
          label: t('header.menu.checkouts'),
          path: `${path}/checkouts`,
        }
      )
    }
    setMenu((prev) => [...prev, ...toConcat])
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [prizesCount, setMenu, campaign?.activation?.disableRankingVisualization])

  useEffect(
    () =>
      setMenu((prev) => {
        return prev?.map((i) => {
          return {
            ...i,
            label: t(`header.menu.${i.path.split('/').pop()}`),
          }
        })
      }),
    [i18n.language, t]
  )

  const parseRankingCompare = useCallback(() => {
    if (!userRankingLast || userRanking?.position === userRankingLast?.position) {
      return <i className="fa-solid fa-equals arrow gold"></i>
    }
    if (userRanking?.position < userRankingLast?.position) {
      return <i className="fa-solid fa-arrow-up arrow green"></i>
    }
    if (userRanking?.position > userRankingLast?.position) {
      return <i className="fa-solid fa-arrow-down arrow red"></i>
    }
  }, [userRanking, userRankingLast])

  return (
    <div className="wrapper-all-engage-header">
      <header className="engage-header">
        <div className="box-head">
          <figure>
            <img
              className="img-fluid"
              title={userInCampaign?.username}
              alt={userInCampaign?.username}
              src={`https://storage.googleapis.com/squid-profile-pictures/${userInCampaign?.idNetwork}.jpg`}
              onError={({ currentTarget }) => {
                currentTarget.onerror = null
                currentTarget.src = defaultImage
              }}
            />
            {userRanking?.position === 1 ? <i className="fa-solid fa-crown icon-crown"></i> : null}
          </figure>
          <span className="caption" title={`@${userInCampaign?.username}`}>
            @{userInCampaign?.username}
          </span>
        </div>
        <div className="box-head">
          <h3>
            {userRanking?.position ? `#${userRanking?.position}` : '-'}
            {parseRankingCompare()}
          </h3>
          <span>{t('header.position')}</span>
        </div>
        <div className="box-head">
          <h3>{userRanking?.total?.toLocaleString(i18n.language) || 0}</h3>
          <span>{t('header.points')}</span>
        </div>
      </header>
      <nav className="engage-nav">
        <ul className="tabs-header line-style" role="menu">
          {menu?.map((item, index) => (
            <li
              key={index}
              className={`tab ${window.location.pathname?.includes(item.path) ? 'active' : ''}`}
              onClick={() => navigate(item.path)}
              data-href={item.path}
              role="menuitem"
            >
              <Link to={item.path}>{item.label}</Link>
            </li>
          ))}
        </ul>
      </nav>
    </div>
  )
}
